import React from "react";
import AssetManager from "../AssetManager";

const CustomButton: React.FC<CustomButtonProps> = ({
  label,
  icon,
  onClick,
  containerClass,
}) => {
  return (
    <div
      className={`custom-button-container ${containerClass}`}
      onClick={onClick}
    >
      <img
        src={AssetManager.getAsset(icon)}
        alt="icon"
        className="custom-button-icon"
      />
      <p className="custom-button-label">{label}</p>
    </div>
  );
};

export default CustomButton;

export interface CustomButtonProps {
  label: string;
  icon: string;
  onClick: () => void;
  containerClass?: string;
}
